// extracted by mini-css-extract-plugin
export default {"apart":"style_apart__sYwP1","content":"style_content__lsnTv","item":"style_item__qbJlM","button":"style_button__B4s9G"};